import { roles } from "../config/config";

export const filesPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.magazziniere,
  roles.contabile,
  roles.dipendente,
  roles.grafico,
  roles.agenteRoydermal,
  roles.agenteRoypet,
  roles.agenteCompleto,
  roles.agenteValderma,
];
